import { forIn } from 'lodash'
import { Path } from 'config/portal'
import { AgreementsMapping } from 'config/products'
import { RecordTypes } from 'flatfile-config'
import { notificationServicesFields } from 'config/notificationsFields'
import { convertNumber } from 'utils'
import { PlanConfirmationForm } from '../forms'
import { selectors } from '../reducer'
import * as actions from '../actions'
import * as apiActions from 'api-actions'
import createPlanConfirmationView, {
  createGetActiveBenefitAboveThresholdParticipants,
} from '../../products/views/createPlanConfirmationView'

const getNextPath = (values, history) => {
  const planStatuses = []
  forIn(values, ({ planStatus }, id) => {
    if (id !== 'confirm') planStatuses.push({ id, planStatus })
  })
  return {
    pathname: Path.REVIEW_NOTIFICATION_MATERIALS,
    state: { search: history.location.state?.search, planStatuses },
  }
}

const getVestedBalance = (participant) =>
  convertNumber(participant[notificationServicesFields.BAL_VESTED.key])

const isSBR = (participant) =>
  participant[notificationServicesFields.REASON_ROLLOUT_REQ.key] === 'SBR'

export default createPlanConfirmationView({
  PlanConfirmationFormComponent: PlanConfirmationForm,
  agreementsMapping: AgreementsMapping.NOTIFICATIONS_PLAN_MATCHING,
  nextPath: getNextPath,
  uploadFilePath: '/notification-services/upload-file',
  allParticipantsRemovedPath: Path.NOTIFICATIONS_HISTORY,
  recordType: RecordTypes.ARO_PARTICIPANT,
  getActiveBenefitAboveThresholdParticipants:
    createGetActiveBenefitAboveThresholdParticipants(getVestedBalance, isSBR),
  selectors,
  actions,
  fetchAgreementsAction: apiActions.fetchNotificationsAgreements,
  agreementsSelectorFn: (state) => selectors.notificationsAgreements(state),
})
